import React from 'react';
import cx from 'classnames';

import { SiteConfigManager, useApplicationState, useTranslation } from '@atlas/core';
import { HEADER_LAYOUT_TYPES, HeaderMobileLayout } from '@atlas/ui';

import Logo from 'common/Widgets/Logo/Logo';

import HeaderContent from './HeaderContent';
import HeaderSkeleton from './HeaderSkeleton';

const Header = ({ isDetailPage, isIframe }) => {
  const userData = useApplicationState();
  const translations = useTranslation();
  const translationsLoaded = Object.keys(translations).length > 0;

  const layout =
    SiteConfigManager.getConfig('config.config.general.mobileHeaderView') ||
    HEADER_LAYOUT_TYPES.HEADER1;
  const headerClassName = cx('header', { 'hidden-header': isDetailPage && isIframe });

  if (translationsLoaded && userData.resolved) {
    return (
      <HeaderMobileLayout className={headerClassName} type={layout}>
        <HeaderMobileLayout.Logo>
          <Logo redirectTo="/" />
        </HeaderMobileLayout.Logo>
        <HeaderMobileLayout.Content>
          <HeaderContent />
        </HeaderMobileLayout.Content>
      </HeaderMobileLayout>
    );
  }

  return <HeaderSkeleton />;
};

export default Header;
